import { Trans, useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { ZapIcon } from "lucide-react";

import { cn } from "@/shared/lib";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/shared/ui/sidebar";

import { useIngestStatus } from "../../api/useIngestStatus";

// Как приходят матчи — строкой под «Последними матчами» (макет «15г»,
// `design/prototype/ReturnNoMatches.dc.html`): это состояние матчей, а не раздел, поэтому
// отдельного пункта «Матчи сразу» в меню нет. Без программы — «Новые — через 2–3 дня» и
// ссылка «Получать сразу», с программой — зелёное «Матчи приходят сразу». В свёрнутом меню —
// значок с подсказкой. Пока статус грузится — ничего.
export const FreshMatchesStatus = () => {
  const { t } = useLingui();
  const status = useIngestStatus();
  if (status.isPending) {
    return null;
  }
  const active = status.data?.active === true;
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          size="lg"
          tooltip={
            active
              ? t`Matches arrive right away`
              : t`New matches take 2–3 days. Get them right away`
          }
          className={cn(
            active
              ? "text-good hover:text-good [&>svg]:text-good"
              : "border border-border-strong bg-surface-raised group-data-[state=collapsed]/sidebar:border-0 [&>svg]:text-accent",
          )}
        >
          <Link to="/fresh-matches" data-fresh-matches={active ? "on" : "off"}>
            <ZapIcon aria-hidden="true" />
            {active ? (
              <span className="text-[13px]">
                <Trans>Matches arrive right away</Trans>
              </span>
            ) : (
              <span className="flex min-w-0 flex-col leading-tight">
                <span className="text-[13px] text-foreground-soft">
                  <Trans>New ones — in 2–3 days</Trans>
                </span>
                <span className="text-[13px] font-semibold text-accent">
                  <Trans>Get them right away</Trans>
                </span>
              </span>
            )}
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
